import script from "./DropdownButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownButton.vue?vue&type=script&setup=true&lang=js"

import "./DropdownButton.vue?vue&type=style&index=0&id=45c84fc9&lang=scss"

const __exports__ = script;

export default __exports__